/**
 * обновление контента шапки и подвала из pjax ответа
 */
import {Widget} from "base/assets/js/widget/Widget.js";
import {CWays} from "base/assets/js/widget/CWays.js";
import {Sb} from "base/assets/js/widget/Sb.js";

export class Layout extends Widget {

	aBodyClasses = [ 'body_column', 'body_full' ];
	aAuthClasses = [ 'auth_guest', 'auth_user' ];

	run() {
	}

	update( oOpts ) {

		// универсальный случай, когда переменная из Layout должна попасть в содержимое тега
		// если input попадет в value
		// например <div class="_Layout-Data" data-key="sLayoutOptKey">
		// oOpts[ 'sLayoutOptKey' ] попадет в внутрь div
		this._el( 'Data[]?' ).forEach( ( eData ) => {
			if( eData.tagName.toLowerCase() === 'input' ) {
				eData.value = oOpts[ eData.getAttribute( 'data-key' ) ];
			} else {
				eData.textContent = oOpts[eData.getAttribute( 'data-key' )];
			}
		} );

		// универсальный случай, когда переменные Layout должны попасть в какие то атрибуты тега
		// например <a class="_Layout-Attr" data-attrs="href=sLayoutOptNickHref,rel=sLayoutOptNickRel"/>
		// oOpts[ 'sLayoutOptNickHref' ] попадет в атрибут href
		// oOpts[ 'sLayoutOptNickRel' ] попадет в атрибут rel
		this._el( 'Attr[]?' ).forEach( ( eData ) => {
			const { oAttrs } = this._data( { 'attrs': 'mod:oAttrs' }, eData );
			for( let sAttr in oAttrs ) {
				let sOptName = oAttrs[ sAttr ];
				eData.setAttribute( sAttr, oOpts[ sOptName ] );
			}
		} );

		/*this._el( 'Show[]?' ).forEach( ( eContext ) => {
			const bShow = !!oOpts[ eContext.getAttribute( 'data-key' )];
			this._mod( eContext, this.sShowClass, bShow );
		} );*/

		for( let sOpt in oOpts ) {
			switch( sOpt ) {
				// case 'bGuest':
				// 	this._mod( '', 'layout_guest', oOpts.bGuest );
				// 	break;
				// case 'iBasketTimeout':
				// 	this._el( 'BasketTimeout' ).setAttribute( 'data-end', oOpts.iBasketTimeout );
				// 	this._other( '>BasketTimeout', Widget, ( oBasketTimeout ) => {
				// 		oBasketTimeout.setCurTime( oOpts.iCurTime );
				// 		oBasketTimeout.reload();
				// 	} );
				// 	break;
				// case 'bPriceAlert':
				// 	this._mod( '', 'with-pricealert', oOpts.bPriceAlert );
				// 	break;
				// case 'bMenu':
				// 	this._mod( '', 'hide-menu', !oOpts.bMenu );
				// 	break;
				// case 'bOptsMode':
				// 	this._mod( '', 'opts-mode', oOpts.bOptsMode );
				// 	break;
				// case 'iBasketCnt':
				// 	this._mod( 'BasketCntBtn?', 'header__btn_basket-active', oOpts.iBasketCnt > 0 );
				// 	this._mod( 'BasketInfo?', 'topbar__basket_active', oOpts.iBasketCnt > 0 );
				// 	if( this._el( 'BasketCnt?' ) ) {
				// 		this._el( 'BasketCnt?' ).textContent = oOpts.iBasketCnt;
				// 	}
				// 	break;
				// case 'eBasketBlock':
				// 	if( this._el( 'BasketBlock?' ) ) {
				// 		this._unlink( this._el( 'BasketBlock?' ) );
				// 		this._el( 'BasketBlock?' ).innerHTML = '';
				// 		this._el( 'BasketBlock?' ).appendChild( oOpts.eBasketBlock );
				// 		//const eParent = this._el( 'BasketBlock?' ).parentNode;
				// 		//eParent.replaceChild( oOpts.eBasketBlock, this._el( 'BasketBlock?' ) );
				// 		this._link( this._el( 'BasketBlock?', true ), true );
				// 	}
				// 	break;
				// case 'mBreadCrumbs':
				// 	this._mod( '', 'hide-breadcrumbs', oOpts.mBreadCrumbs === false );
				// 	if( oOpts.mBreadCrumbs !== false ) {
				// 		if( this._el( 'BreadCrumbs?' ) ) {
				// 			this._el( 'BreadCrumbs?' ).innerHTML = oOpts.mBreadCrumbs;
				// 		}
				// 	}
				// 	break;
				case 'sBodyClass':
					this._mod( '', this.aBodyClasses, oOpts[ sOpt ] );
					break;
				case 'sAuthClass':
					this._mod( '', this.aAuthClasses, oOpts[ sOpt ] );
					break;
				case 'sTerm':
					this._getSb().setTerm( oOpts[ sOpt ] );
					break;
			}
		}

		// чтобы сначала обновился макет, а уже по макету обновились отступы комментариев
		const oCWays = this._rel().typeOf( CWays ).canEmpty().find();
		if( oCWays ) {
			oCWays.run();
		}
	}

	_getSb() {
		if( !this._oSb ) {
			this._oSb = this._rel().typeOf( Sb ).find();
		}
		return this._oSb;
	}
}